<script setup>
import axios from "axios";
import { onMounted, ref, computed } from "vue";

// Load more toggle
const loadPhoto = ref(false);
const loadMore = () => {
    loadPhoto.value = !loadPhoto.value;
};

// Partners data
const partners = ref([]);

// Fetch partners
async function getAllPartner() {
    try {
        const res = await axios.get("/get-all-partner-data");
        partners.value = res.data || [];
    } catch (error) {
        console.error("Error fetching partners:", error);
    }
}

// Computed property for displayed partners
const displayedPartners = computed(() => {
    return loadPhoto.value ? partners.value : partners.value.slice(0, 12);
});

onMounted(() => {
    getAllPartner();
});
</script>

<template>
    <section class="text-gray-600 body-font">
        <div class="container 2xl:px-24 xl:px-0 xl:py-8 py-4 mx-auto">
            <!-- Title -->
            <div class="pb-4 wow animate__animated animate__fadeInLeft">
                <h2
                    class="text-center text-black leading-tight mx-auto font-roboto title-font xl:text-[44px] lg:text-[36px] sm:text-[28px] text-xl lg:mt-4 sm:mb-6 mb-4"
                >
                    {{ $t("partner.title") }}
                </h2>
                <div
                    class="mx-auto border-[3.5px] border-transparent border-t-[#1cbed1] w-36"
                ></div>
            </div>

            <!-- Partners Grid -->
            <div
                class="grid grid-cols-2 lg:grid-cols-6 sm:grid-cols-2 sm:gap-5 gap-4 sm:mt-4 mt-2 sm:mb-12 mb-6"
            >
                <a
                    v-for="(partner, index) in displayedPartners"
                    :key="index"
                    :href="partner?.url"
                    target="_blank"
                    rel="noopener noreferrer"
                    :aria-label="partner?.title"
                    class="block"
                >
                    <div
                        class="py-4 border bg-white shadow-lg hover:shadow-xl shadow-gray-200 hover:shadow-gray-300 rounded wow animate__animated animate__fadeInLeft"
                    >
                        <VLazyImage
                            :src="partner?.image"
                            :alt="partner?.title || 'Partner logo'"
                            width="205"
                            height="103"
                            class="w-full h-auto object-contain mx-auto"
                        />
                    </div>
                </a>
            </div>

            <!-- Load More Button -->
            <div class="flex items-center justify-center mx-auto">
                <button
                    @click="loadMore"
                    v-show="partners.length > 12"
                    class="bg-[#1cbed1] hover:bg-[#1565C0] py-2 px-6 rounded-md shadow-md hover:shadow-xl transition duration-300 text-white text-[14px] uppercase"
                >
                    {{
                        loadPhoto
                            ? $t("partner.show_less")
                            : $t("partner.show_more")
                    }}
                </button>
            </div>
        </div>
    </section>
</template>

<style scoped></style>
